/**
 * Defines common theme variables needed across multiple js partials
 *
 * @package Embark
 * @since   1.0.0
 */

import { Breakpoints } from '../global/breakpoints';

export const breakpoints = new Breakpoints([
	{
		key: 'xxs',
		min: 320,
	},
	{
		key: 'xs',
		min: 480,
	},
	{
		key: 'grid',
		min: 640,
	},
	{
		key: 'sm',
		min: 768,
	},
	{
		key: 'md',
		min: 1025,
	},
	{
		key: 'menu',
		min: 1090,
	},
	{
		key: 'lg',
		min: 1200,
	},
]);

/**
 * Common elements referenced throughout the project.
 *
 * @since 1.0.0
 */
export const els = {
	html: document.documentElement,
	body: document.body,
	header: document.getElementById('js-site-header'),
	headerInner: document.querySelector('.site-header__inner'),
	navContainer: document.querySelector('.site-header__navigation'),
	mainMenu: document.querySelector('.main-menu'),
	navicon: document.getElementById('js-navicon'),
	naviconTrigger: document.getElementById('js-navicon-trigger'),
	utilities: document.querySelector('.utilities'),
	footer: document.querySelector('.site-footer'),
};
